import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPublicTransportNeighborhood } from "../../../api/transportPublicApi";
import {
  TransportPublicAttribution,
  TransportPublicCtas,
  TransportPublicHero,
  TransportPublicMetrics,
  TransportPublicReportsList,
} from "../../../components/midpoint/transport/public/TransportPublicSections";
import { useTransportPublicSeo, trackTransportPublicEvent } from "../../../hooks/useTransportPublicSeo";
import TransportPublicLayout from "./TransportPublicLayout";

const TransportNeighborhoodMobilityPage = () => {
  const { slug } = useParams();
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState(null);

  useTransportPublicSeo(payload?.seo);

  useEffect(() => {
    let cancelled = false;
    fetchPublicTransportNeighborhood(slug)
      .then((body) => {
        if (!cancelled) {
          setPayload(body);
          trackTransportPublicEvent("transport_public_page_view", {
            pageType: "neighborhood",
            slug,
          });
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load page.");
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (error) {
    return (
      <TransportPublicLayout title="Mobility intelligence">
        <p>{error}</p>
      </TransportPublicLayout>
    );
  }

  if (!payload) {
    return (
      <TransportPublicLayout title="Mobility intelligence">
        <p>Loading neighborhood mobility…</p>
      </TransportPublicLayout>
    );
  }

  return (
    <TransportPublicLayout title="Neighborhood mobility">
      <TransportPublicHero hero={payload.hero} freshness={payload.freshness} />
      <TransportPublicMetrics metrics={payload.keyMetrics} />
      <TransportPublicReportsList mobilityRisks={payload.mobilityRisks} />
      <TransportPublicAttribution
        attribution={payload.attribution}
        methodology={payload.methodology}
      />
      <TransportPublicCtas ctas={payload.ctas} />
    </TransportPublicLayout>
  );
};

export default TransportNeighborhoodMobilityPage;
